import React, {Fragment} from 'react'
import { graphql, StaticQuery, Link } from 'gatsby'
import Logo from '../assets/albert_logo_white.svg'
import { Helmet } from 'react-helmet';
import Seo from './Seo';
import ColorLogoImg from '../assets/logo-colored.svg'

class HeaderPlain extends React.Component{
    constructor(porps){
        super(porps)
    }

    render(){
        

        const {logoColor, colorLogo, headerClass, backto, title} = this.props;
        const { favicon } = this.props.query;
        return(
            <Fragment>
                <Helmet
                    title={title}
                    meta={[
                        {
                        name: "description",
                        content: "Albert är Barnens Digitala Mattelärare. Med tusentals övningar och animerade videos hjälper han dig att förstå matematiken du behöver kunna för just din årskurs.",
                        },
                        {
                        name: "keywords",
                        content: "Albert, Math, Mattelärare, Digitala Mattelärare, matematiken",
                        },
                    ]}
                    link={[
                        { rel: "icon", type: "image/png", sizes: "16x16", href: `${favicon.publicURL}` },
                    ]}
                    script={[
                        {"src": "https://x.klarnacdn.net/kp/lib/v1/api.js", "type": "text/javascript"}
                    ]}
                />
                <Helmet>
                    <script src="https://js.stripe.com/v3/"></script>
                </Helmet>
                <Seo />
               <header className={headerClass}>
                    <div className="custom-container">
                        <Link to="/">

                            {
                                colorLogo ? (
                                    <ColorLogoImg />
                                ) : (

                                    <Logo style={{fill: logoColor}} />
                                )
                            }
                        </Link>
                        {
                            backto && (
                            <Link className="back-to-albert" to="/">
                               Tillbaka till Albert
                            </Link>
                            )
                        }
                    </div>
                </header>
            </Fragment>
        )
    }
}

export default (props) => (
    <StaticQuery
        query= { graphql`
                query {
                    favicon: file(relativePath: {regex: "/faviicon/"}) {
                        publicURL
                    }                    
                }`
            }
        render={(data)  => (
           <HeaderPlain query={data} {...props}/>
        )}
    />
)